<template>
    <div class="navContent s_bf2"  :style="'border-radius:'+data.style.radius+'px' ">
      <div class="navItem" v-for="(v,k) in data.data" :key="k" :class="data.data.length==1?'one_item':''" :style="data.data.length==1?'background-color:'+gobleStyle.themeColor:''">
        <img :src="v.imgUrl.indexOf('http')!=-1?v.imgUrl:navDefIconMap[v.key]" alt="">
        <!-- <span class="fontTrace " :class="'icon-'+v.imgUrl" :style="'color:'+gobleStyle.themeColor"></span> -->
        <p class="s_omit width100 text-ac">{{v.name || '名称'}}</p>
      </div>
    </div>
</template>
<script>
import config from '@/config'
import store from "@/store";
import { ref } from 'vue';
export default {
    props: { data: Object,gobleStyle:Object },
    setup(){
          const info = ref(store.state.user.info);
           // 导航图标映射
      const navDefIconMap = {
        examine:
          info.value.picdomain + "/web_base_assets/scan/report.png", //检验报告
        group:
          info.value.picdomain + "/web_base_assets/scan/group.png", //粉丝社群
        video:
          info.value.picdomain + "/web_base_assets/scan/video.png", //宣传视频
        public:
          info.value.picdomain + "/web_base_assets/scan/te_gzh.png", //公众号
        store:
          info.value.picdomain + "/web_base_assets/scan/store_icon.png", //'云店'
        query:
          info.value.picdomain + "/web_base_assets/scan/query_icon.png", //防伪查询'
        center:
          info.value.picdomain + "/web_base_assets/scan/center_icon.png", //'会员中心',
        customize:
          info.value.picdomain + "/web_base_assets/scan/logisticsPulice.png", //'自定义',
      };
      return{
        assetsOss:config.oss[process.env.VUE_APP_type],
        navDefIconMap
      }
    }
}
</script>
<style lang="less" scoped>
.navContent {
  display: flex;
  flex-wrap: wrap;
  padding:10px 0;
  justify-content: space-between;
  width: 100%;
    justify-content: space-around;
  .navItem{
    width: 32%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-size: 14px;
    img{
      width: 30px;
      height: 30px;
    }
  }
    .one_item{
    width: 100%;
    display: flex;
    flex-direction: row;
    background-color:rgb(79, 161, 252);
    border-radius: 20px;
    padding: 10px;
    color: #fff;
    img{
      display: none;
    }
  }
}
</style>